import { c as chatUnreadTimestamps } from './user-prefs-f52d234f.js';

const parseMessageForTarget = (message) => {
  let parsedMessage = null;
  try {
    const parsed = JSON.parse(message.message);
    const { target, message: m } = parsed;
    if (target === undefined || m === undefined) {
      parsedMessage = message;
    }
    else {
      parsedMessage = Object.assign(Object.assign({}, message), { targetUserIds: target, message: m });
    }
  }
  catch (error) {
    parsedMessage = message;
  }
  return parsedMessage;
};
/**
 * Generate a unique chat group key used in `<dyte-chat-messages-ui />`
 * @param ids An array of user ids
 * @returns A unique key from the user ids
 */
function generateChatGroupKey(ids) {
  return ids.sort((a, b) => a.localeCompare(b)).join('_');
}
function handleFilesDataTransfer(items, callback) {
  if (items == null)
    return;
  for (const item of items) {
    if (item.kind === 'file') {
      const file = item.getAsFile();
      if (item.type.startsWith('image/')) {
        callback('image', file);
      }
      else {
        callback('file', file);
      }
    }
  }
}
function getChatGroups({ messages, participants, selfUserId }) {
  const groups = {};
  // create empty chat groups for all participants
  for (const participant of participants) {
    groups[generateChatGroupKey([participant.userId, selfUserId])] = [];
  }
  messages.forEach((message) => {
    var _a;
    const parsedMessage = parseMessageForTarget(message);
    let key = 'everyone';
    if (((_a = parsedMessage.targetUserIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
      const allParticipants = new Set([
        parsedMessage.userId,
        ...parsedMessage.targetUserIds,
      ]);
      key = generateChatGroupKey(Array.from(allParticipants));
    }
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push({ type: 'chat', message: parsedMessage });
  });
  return groups;
}
function getUnreadChatCounts({ messages, selfUserId, selectedGroupId, participants, }) {
  var _a;
  const groups = getChatGroups({
    messages,
    selfUserId,
    participants,
  });
  const unreadCounts = {};
  for (const key in groups) {
    const lastReadTimestamp = (_a = chatUnreadTimestamps[key]) !== null && _a !== void 0 ? _a : 0;
    if (key === selectedGroupId) {
      // reset count to 0 when you select a group
      unreadCounts[key] = 0;
      chatUnreadTimestamps[key] = new Date();
    }
    else {
      unreadCounts[key] = groups[key].filter((c) => {
        return (c.type == 'chat' && c.message.time > lastReadTimestamp && c.message.userId !== selfUserId);
      }).length;
    }
  }
  return unreadCounts;
}
function getParticipantUserId({ groupId, selfUserId, }) {
  return groupId.split('_').find((id) => id != selfUserId);
}

export { getChatGroups as a, getUnreadChatCounts as b, getParticipantUserId as c, generateChatGroupKey as g, handleFilesDataTransfer as h, parseMessageForTarget as p };
